import { emptyEditorJSON } from '../constants';
import { Cell } from '../types';
import { createUID } from './createUID';

export function createCell(type: 'normal' | 'header'): Cell {
  return {
    colSpan: 1,
    id: createUID(),
    json: emptyEditorJSON,
    type,
    width: null,
  };
}
